import { createRouter, createWebHistory } from 'vue-router'
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import store from "@/store";
import { isPortalUnderMaintenance } from "@/utils/portalMaintenance";

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/MainPages/LoginPage.vue')
  },
  {
    path: '/portal-maintenance',
    name: 'PortalMaintenance',
    component: () => import(/* webpackChunkName: "portal-maintenance" */ '../views/ChildPages/PortalMaintence.vue')
  },
  {
    path: '/api-docs',
    redirect: '/landing/api-docs'
  },
  {
    path: '/landing',
    name: 'LandingPage',
    component: () => import(/* webpackChunkName: "landing" */ '../views/MainPages/LandingPage.vue'),
    redirect: '/landing/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/ChildPages/Dashboard.vue')
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import(/* webpackChunkName: "users" */ '../views/ChildPages/Users.vue')
      },
      {
        path: 'facility',
        name: 'Facility',
        component: () => import(/* webpackChunkName: "facility" */ '../views/ChildPages/Facility.vue')
      },
      {
        path: 'masters',
        name: 'Masters',
        component: () => import(/* webpackChunkName: "masters" */ '../views/ChildPages/Masters.vue')
      },
       {
        path: 'utilities',
        name: 'Utilities',
        component: () => import(/* webpackChunkName: "Utilities" */ '../views/ChildPages/Utilities.vue')
      },
      {
        path: 'user-template',
        name: 'UserTemplate',
        component: () => import(/* webpackChunkName: "user-template" */ '../views/ChildPages/UserTemplate.vue')
      },
      {
        path: 'ticket-management',
        name: 'TicketManagement',
        component: () => import(/* webpackChunkName: "ticket-management" */ '../components/TicketMangement/Card/TicketList.vue')
      },
     
      {
        path: 'facility/:facilityId/pharmacist',
        name: 'FacilityUsers',
        component: () => import(/* webpackChunkName: "facility-pharmacist" */ '../components/Facility/Cards/FacilityPharmacist.vue')
      },
      {
        path: 'facility/:facilityId/reports',
        name: 'FacilityUsersReports',
        component: () => import(/* webpackChunkName: "facility-reports" */ '../components/MyFacility/Cards/Reports.vue')
      },
      {
        path: 'resident',
        name: 'Resident',
        component: () => import(/* webpackChunkName: "resident" */ '../components/MyFacility/Cards/Resident.vue')
      },
      {
        path: 'my-facility/:facilityId/resident',
        name: 'FacilityResident',
        component: () => import(/* webpackChunkName: "facility-resident" */ '../components/MyFacility/Cards/Resident.vue')
      },
      {
        path: 'physician',
        name: 'Physician',
        component: () => import(/* webpackChunkName: "physician" */ '../components/MyFacility/Cards/Physician.vue')
      },
      {
        path: 'my-facility/:facilityId/physician',
        name: 'FacilityPhysician',
        component: () => import(/* webpackChunkName: "facility-physician" */ '../components/MyFacility/Cards/Physician.vue')
      },
      {
        path: 'category',
        name: 'Category',
        component: () => import(/* webpackChunkName: "category" */ '../views/ChildPages/UserCategory.vue')
      },
      {
        path: 'labs',
        name: 'Labs',
        component: () => import(/* webpackChunkName: "labs" */ '../views/ChildPages/UserLabs.vue')
      },
      {
        path: 'my-facility',
        name: 'MyFacility',
        component: () => import(/* webpackChunkName: "my-facility" */ '../views/ChildPages/MyFacility.vue')
      },
      {
        path: 'pending-facility-review',
        name: 'PendingFacilityReview',
        component: () => import(/* webpackChunkName: "pending-facility-review" */ '../views/ChildPages/PendingFacilityReview.vue')
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/ChildPages/Settings.vue')
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => import(/* webpackChunkName: "reports" */ '../components/MyFacility/Cards/Reports.vue')
      },
       {
        path: 'userreport',
        name: 'userreport',
        component: () => import(/* webpackChunkName: "reports" */ '../components/MyFacility/Cards/Reports.vue')
      },
       {
        path: 'adminreport',
        name: 'adminreport',
        component: () => import(/* webpackChunkName: "reports" */ '../components/MyFacility/Cards/Reports.vue')
      },
      {
        path: 'my-facility/:facilityId/reports',
        name: 'FacilityReports',
        component: () => import(/* webpackChunkName: "facility-reports" */ '../components/MyFacility/Cards/Reports.vue')
      },
      {
        path: 'my-profile',
        name: 'MyProfile',
        component: () => import(/* webpackChunkName: "my-profile" */ '../views/ChildPages/MyProfile.vue')
      },
      {
        path: 'all-recommendations',
        name: 'AllRecommendations',
        component: () => import(/* webpackChunkName: "all-recommendations" */ '../components/MyFacility/Cards/AllRecommendation.vue')
      },
      {
        path: 'my-facility/:facilityId/all-recommendations',
        name: 'FacilityAllRecommendations',
        component: () => import(/* webpackChunkName: "facility-all-recommendations" */ '../components/MyFacility/Cards/AllRecommendation.vue')
      },
      {
        path: 'pdf-extraction',
        name: 'PdfExtraction',
        component: () => import(/* webpackChunkName: "pdf-extraction" */ '../components/MyFacility/Cards/PdfExtraction.vue')
      },
      {
        path: 'my-facility/:facilityId/pdf-extraction',
        name: 'FacilityPdfExtraction',
        component: () => import(/* webpackChunkName: "facility-pdf-extraction" */ '../components/MyFacility/Cards/PdfExtraction.vue')
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: () => import(/* webpackChunkName: "announcement" */ '../views/ChildPages/Announcement.vue')
      },
      {
        path: 'reviewed-residents',
        name: 'ReviewedResidents',
        component: () => import(/* webpackChunkName: "reviewed-residents" */ '../views/ChildPages/ReviewedResidents.vue')
      },
       {
        path: 'license-users',
        name: 'LicenseUsers',
        component: () => import(/* webpackChunkName: "reviewed-residents" */ '../views/ChildPages/LicenseUsers.vue')
      },
      {
        path: 'files',
        name: 'Files',
        component: () => import(/* webpackChunkName: "files" */ '../views/ChildPages/Files.vue')
      },
      {
        path: 'my-invoice',
        name: 'MyInvoice',
        component: () => import(/* webpackChunkName: "my-invoice" */ '../views/ChildPages/MyInvoice.vue')
      },
      {
        path: 'checklist',
        name: 'Checklist',
        component: () => import(/* webpackChunkName: "checklist" */ '../views/ChildPages/Checklist.vue')
      },
      {
        path: 'user-checklist',
        name: 'UserChecklist',
        component: () => import(/* webpackChunkName: "user-checklist" */ '../components/MyFacility/Cards/UserChecklist.vue')
      },
      {
        path: 'my-facility/:facilityId/user-checklist',
        name: 'FacilityUserChecklist',
        component: () => import(/* webpackChunkName: "facility-user-checklist" */ '../components/MyFacility/Cards/UserChecklist.vue')
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import(/* webpackChunkName: "invoice" */ '../views/ChildPages/Invoice.vue')
      },
      {
        path: 'api-and-integration',
        name: 'ApiAndIntegration',
        component: () => import(/* webpackChunkName: "api-and-integration" */ '../views/ChildPages/ApiAndIntegration.vue')
      },
      {
        path: 'api-docs',
        name: 'ApiDocs',
        component: () => import(/* webpackChunkName: "api-docs" */ '../views/MainPages/ApiDocsPage.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path === "/") {
    next();
    return;
  }

  try {
    const session = await fetchAuthSession();
    const hasToken = Boolean(
      session?.tokens?.accessToken || session?.tokens?.idToken
    );

    if (!hasToken) {
      try {
        await signOut();
      } catch (error) {
        console.error("Sign out failed in route guard:", error);
      }
      next("/");
      return;
    }

    const underMaintenance = isPortalUnderMaintenance(store.state.currentUser);
    if (underMaintenance && to.name !== "PortalMaintenance") {
      next({ name: "PortalMaintenance" });
      return;
    }
    if (!underMaintenance && to.name === "PortalMaintenance") {
      next("/landing/dashboard");
      return;
    }

    next();
  } catch (error) {
    console.error("Route auth guard error:", error);
    try {
      await signOut();
    } catch (signOutError) {
      console.error("Sign out failed after route guard error:", signOutError);
    }
    next("/");
  }
});

export default router

